import SaveKitInventariable from "../../shared/component/save-kit-inventariable/SaveKitInventariable";

export default function KitInventarioCreate() {


  return (
    <SaveKitInventariable title="Crear Kit" />
  )

}